import styled from '@emotion/styled';

export const OTPContainer = styled.div`
	display: flex;
	flex-direction: row;
	gap: 1rem;

	> .button {
		flex: 1 0 auto;
		height: 4.5rem;

		body[dir='rtl'] & {
			height: 5.5rem;
		}
	}
`;

export const OTPStringContainer = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
`;
